import { Chains } from "../constants/constants";
var EVMChains = [Chains.Ethereum, Chains.Avalanche, Chains.Binance];
export var isEVMChain = function (chain) {
    return EVMChains.includes(chain);
};
export var isSolanaChain = function (chain) {
    return chain === Chains.Solana;
};
//# sourceMappingURL=chains.js.map